import React from 'react';

const LABEL_STYLE = { display: 'block', fontSize: 12, color: '#555', marginBottom: 4 };
const TEXTAREA_STYLE = { display: 'block', width: '100%', fontSize: 14, resize: 'vertical', boxSizing: 'border-box' };

// The Customer and Staff comments on a Quote or Sales Order, shown below the
// lines beside the totals (where QuickBooks puts its invoice message). The
// Staff Comment is tinted and labelled so it reads as internal at a glance.
function DocumentComments({ customerComment, onCustomerCommentChange, staffComment, onStaffCommentChange, customerHint, disabled }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12, maxWidth: 520 }}>
      <label>
        <span style={LABEL_STYLE}>Customer Comment</span>
        <textarea
          className="styled-input"
          placeholder={customerHint}
          value={customerComment}
          onChange={(e) => onCustomerCommentChange(e.target.value)}
          disabled={disabled}
          rows={3}
          style={TEXTAREA_STYLE}
        />
      </label>
      <label style={{ background: '#fff8e1', border: '1px solid #f0dca0', borderRadius: 8, padding: 10 }}>
        <span style={LABEL_STYLE}>Staff Comment <span style={{ color: '#7a5c00', fontWeight: 600 }}>· Staff only</span></span>
        <textarea
          className="styled-input"
          placeholder="Seen by staff only"
          value={staffComment}
          onChange={(e) => onStaffCommentChange(e.target.value)}
          disabled={disabled}
          rows={3}
          style={TEXTAREA_STYLE}
        />
      </label>
    </div>
  );
}

export default DocumentComments;
